export interface Action {
  label: string
  action: 'retry' | 'navigate'
  path?: string
  type: 'primary' | 'secondary'
  color?: string
}

export interface ErrorConfig {
  name: string // Added name property
  message: string
  actions: Action[] // Changed to array for iterability
}

export const errorConfigs: Record<string, ErrorConfig> = {
  // Auth Transfer Preparation Errors
  'missing-destination': {
    name: 'Missing Destination',
    message: 'Invalid search param.',
    actions: [
      { label: 'Go Back', action: 'navigate', path: '/', type: 'primary' }
    ]
  },
  'invalid-domain': {
    name: 'Invalid Domain',
    message: 'Invalid search param.',
    actions: [
      { label: 'Go Back', action: 'navigate', path: '/', type: 'primary' }
    ]
  },
  'no-user': {
    name: 'No User',
    message: 'You are not logged in.',
    actions: [
      { label: 'Go Back', action: 'navigate', path: '/', type: 'primary' }
    ]
  },
  'token-error': {
    name: 'Token Error',
    message: 'Internal error',
    actions: [
      { label: 'Retry', action: 'retry', type: 'primary' },
      { label: 'Go Back', action: 'navigate', path: '/', type: 'secondary' }
    ]
  },

  // Auth Transfer Verification Errors
  'missing-params': {
    name: 'Missing Parameters',
    message: 'Invalid search param.',
    actions: [
      { label: 'Go Home', action: 'navigate', path: '/', type: 'primary' }
    ]
  },
  'invalid-argument': {
    name: 'Invalid Argument',
    message: 'Invalid authentication request.',
    actions: [
      { label: 'Retry', action: 'retry', type: 'primary' },
      { label: 'Go Home', action: 'navigate', path: '/', type: 'secondary' }
    ]
  },
  'deadline-exceeded': {
    name: 'Deadline Exceeded',
    message: 'Request timed out.',
    actions: [
      { label: 'Retry', action: 'retry', type: 'primary' },
      { label: 'Go Home', action: 'navigate', path: '/', type: 'secondary' }
    ]
  },
  'internal': {
    name: 'Internal Error',
    message: 'An unexpected error occurred.',
    actions: [
      { label: 'Retry', action: 'retry', type: 'primary' },
      { label: 'Go Home', action: 'navigate', path: '/', type: 'secondary' }
    ]
  }
}
